import React from 'react';
import LongText from '../Elements/LongText';
import LookupText from '../Elements/LookupText';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import urlHelper from '../Helpers/urlHelper';
import FaIcon from '../Elements/FaIcon';

export default class TpPrepaymentTpClientInvoiceLineItem {
  constructor(item) {
    if (item === undefined) {
      this.TpClientInvoiceId = '';
      this.ClientName = '';
      this.ClientId = '';
      this.LineItemId = '';
      this.Name = '';
      this.InitialTotalDue = '';
      this.LineItemCredit = '';
      this.Outstanding = '';
      this.OutstandingVat = '';
      this.OutstandingReimb = '';
      this.TpClientInvoiceId = '';
      this.CurrencyCode = '';
      this.ProjectId = '';
      this.ServiceId = '';
      this.OpportunityId = '';
      this.LineItemTypeId = '';
      this.LineItem = '';
      this.Paid = '';

      this.Tax = '';
    } else {
      this.TpClientInvoiceId = item.tpClientInvoiceId;
      this.ClientName = item.clientName;
      this.ClientId = item.clientId;
      this.LineItemId = item.lineItemId;
      this.Name = item.name;
      this.InitialTotalDue = item.initialTotalDue;
      this.LineItemCredit = item.lineItemCredit;
      this.Outstanding = item.outstanding;
      this.OutstandingVat = item.outstandingVat;
      this.OutstandingReimb = item.outstandingReimb;
      this.TpClientInvoiceId = item.tpClientInvoiceId;
      this.CurrencyCode = item.currencyCode;
      this.ProjectId = item.projectId;
      this.ServiceId = item.serviceId;
      this.OpportunityId = item.opportunityId;
      this.LineItemTypeId = item.lineItemTypeId;
      this.LineItem = item.lineItem;
      this.Paid = item.paid;

      this.Tax = item.tax;
      this.CurrentTotalFee = item.currentTotalFee;
      this.Description = item.name;
      this.ProjectName = item.projectName;
    }
    this.Selected = false;
  }

  static nameOfTheItemDetailList() {
    return 'Third-Party Client Invoice Line Item Details';
  }

  static MoneyFields = [
    'InitialTotalDue',
    'Outstanding',
    'LineItemCredit',
    'OutstandingVat',
    'OutstandingReimb',
    'Tax',
    'CurrentTotalFee',
  ];

  static Currency() {
    return 'CurrencyCode';
  }

  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return '';
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'TpClientInvoiceId', label: 'Bare Invoice #', className: 'text-left' },
        { name: 'InitialTotalDue', label: 'Client Fee', className: 'text-left' },
        {
          name: (item) => (
            <LookupText
              lookupId={42}
              value={item.LineItemTypeId}
            />
          ),
          label: 'Type',
          className: 'text-left',
        },
        { label: 'Client', name: 'ClientName', className: 'text-left' },
        {
          name: (item) => TpPrepaymentTpClientInvoiceLineItem.getProjectContentLink(item),
          label: 'Project',
          className: 'text-left',
          width: TabListTableCellWidthEnum.Double,
        },
        {
          name: 'Description',
          label: 'Description',
          className: 'text-left',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        { name: 'InitialTotalDue', label: 'Initial Total', className: 'text-left' },
        { name: 'Paid', label: 'Paid', className: 'text-left' },
        { name: 'CurrentTotalFee', label: 'Current Due', className: 'text-left' },
        { name: 'LineItemCredit', label: 'Credit', className: 'text-left' },
        { name: 'Tax', label: 'Tax', className: 'text-left' },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Line Item ID',
        orderById: 'LineItemId',
        data: TpPrepaymentTpClientInvoiceLineItem.GetDetailCellContent,
        minWidth: 10,
      },
      { label: 'Name', orderById: 'Name', data: TpPrepaymentTpClientInvoiceLineItem.getNameCellContent, minWidth: 40 },
      {
        label: 'Type',
        orderById: 'LineItemType',
        data: (item) =>
          !item.LineItemTypeId ? (
            'Assignment'
          ) : (
            <LookupText
              lookupId={42}
              value={item.LineItemTypeId}
            />
          ),
        minWidth: 20,
      },
      { label: 'Initial Total', orderById: 'InitialTotalDue', data: 'InitialTotalDue', minWidth: 10 },
      { label: 'Credit', orderById: 'LineItemCredit', data: 'LineItemCredit', minWidth: 10 },
      { label: 'Outstanding', orderById: 'Outstanding', data: 'Outstanding', minWidth: 10 },
      {
        label: 'Fee Tax',
        orderById: 'OutstandingVat',
        data: 'OutstandingVat',
        minWidth: 10,
      },
      {
        label: 'Reimbursement Tax',
        orderById: 'OutstandingReimb',
        data: 'OutstandingReimb',
        minWidth: 10,
      },
    ];
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.LineItemId,
      '',
      '',
      'tpclientprepaymentdetails',
      `id=${item.LineItemId}`,
      'Open up in a new tab'
    );
  }

  static getNameCellContent(item) {
    return (
      <LongText
        text={item.Name ? item.Name : ' '}
        maxLength={100}
      />
    );
  }

  static getProjectContentLink(item) {
    return (
      <div className='row'>
        <div className='col-9 text-left'>{item.ProjectName}</div>
        <div
          className='col-3 text-left link p-0 border-0'
          onClick={() => TpPrepaymentTpClientInvoiceLineItem.clickOnProjectChangeLink(item)}
        >
          <FaIcon iconName='fa-solid fa-edit' /> Change Third-Party Project
        </div>
      </div>
    );
  }

  static clickOnProjectChangeLink(item) {
    alert('Empty function');
  }
}
